import StripeResultDialog from "@/components/StripeResultDialog";
import routes from "@/router/routes";
import { useState } from "react";

const CancelPage = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(true);

    return (
        <StripeResultDialog
            buttonKey="stripe.cancel.continue"
            descriptionKey="stripe.cancel.description"
            isOpen={isDialogOpen}
            onOpenChange={setIsDialogOpen}
            redirectPath={routes.selectLicense}
            titleKey="stripe.cancel.title"
            type="cancel"
        />
    );
};

export default CancelPage;
